import { Button, Rating, Space, Stack, Text } from '@mantine/core';
import { OtherParticipantNotAvailable } from './ParticipantNotAvailable';
import { useApp } from '../../../../context/AppContext';
import { primaryColor } from '../../../../constants/theme';
import { useNavigate } from 'react-router-dom';

interface CallEndedProps {
  participantName: string;
  participantProfilePicture: string;
}

export const CallEnded = ({
  participantName,
  participantProfilePicture,
}: CallEndedProps) => {
  const { scrollAreaHeight } = useApp();
  const navigate = useNavigate();

  return (
    <Stack h={scrollAreaHeight}>
      <OtherParticipantNotAvailable
        participantName={participantName}
        participantProfilePicture={participantProfilePicture}
        message="Thank you for your call"
      >
        <Text c="dimmed">Please rate your call</Text>
        <Rating size="lg" />
        <Space h={10} />
        <Button
          color={primaryColor}
          w="200"
          onClick={() => navigate('/bookings')}
        >
          Back to bookings
        </Button>
      </OtherParticipantNotAvailable>
    </Stack>
  );
};
